import { PointerLockControls } from "@controllers/controls";
import { paused } from "@stores";
import { KeyBindings, MouseCodes } from "./consts";
class PlayerInputController {
    pointerLockControls;
    FORWARD;
    BACK;
    LEFT;
    RIGHT;
    RUNNING;
    JUMPING;
    SHOOTING;
    AIMING;
    static instance;
    /**
     * PlayerInputController handles keyboard events.
     * @param gunController The entity's gun controller.
     * @private
     */
    constructor(gunController) {
        this.pointerLockControls = PointerLockControls.getInstance();
        this.FORWARD = false;
        this.BACK = false;
        this.LEFT = false;
        this.RIGHT = false;
        this.RUNNING = false;
        this.JUMPING = false;
        this.SHOOTING = false;
        this.AIMING = false;
        this.listen(gunController);
    }
    /**
     * Listen to keyboard input.
     * @param gunController The entity's gun controller.
     */
    listen(gunController) {
        window.addEventListener("keydown", event => {
            if (paused())
                return;
            this.handleMovement(event, true);
            this.handleRunning(event, true);
            this.handleJumping(event, true);
            this.handleGunControls(event, gunController);
        });
        window.addEventListener("keyup", event => {
            if (paused())
                return;
            this.handleMovement(event, false);
            this.handleRunning(event, false);
            this.handleJumping(event, false);
        });
        window.addEventListener("mousedown", event => {
            if (paused())
                return;
            this.handleShooting(event, true);
        });
        window.addEventListener("mouseup", event => {
            if (paused())
                return;
            this.handleShooting(event, false);
        });
    }
    /**
     * Handle player movement based on keyboard input.
     * @param event The keyboard event that triggered the action.
     * @param active Whether the function should activate or deactivate a direction.
     */
    handleMovement(event, active) {
        if (event.code === KeyBindings.FORWARD)
            this.FORWARD = active;
        if (event.code === KeyBindings.BACK)
            this.BACK = active;
        if (event.code === KeyBindings.LEFT)
            this.LEFT = active;
        if (event.code === KeyBindings.RIGHT)
            this.RIGHT = active;
    }
    /**
     * Handle player running mechanics based on keyboard input.
     * @param event The keyboard event that triggered the action.
     * @param active Whether the function should activate or deactivate running.
     */
    handleRunning(event, active) {
        if (event.code === KeyBindings.RUN)
            this.RUNNING = active;
    }
    /**
     * Handle player jumping mechanics based on keyboard input.
     * @param event The keyboard event that triggered the action.
     * @param active Whether the function should activate or deactivate jumping.
     */
    handleJumping(event, active) {
        if (event.code === KeyBindings.JUMP)
            this.JUMPING = active;
    }
    /**
     * Handle shooting for an entity.
     * @param event The mouse event that triggered the action.
     * @param active Whether the function should activate or deactivate.
     */
    handleShooting(event, active) {
        const isLeftMouseButton = event.button === MouseCodes.LEFT;
        const isRightMouseButton = event.button === MouseCodes.RIGHT;
        if (paused() || !this.pointerLockControls.getIsLocked)
            return;
        if (isLeftMouseButton)
            this.SHOOTING = active;
        if (isRightMouseButton)
            this.AIMING = active;
    }
    /**
     * Register gun controls with the input listener.
     * This enables switching between guns, reloading and switing between firing modes.
     * @param event The keyboard event that triggered the action.
     * @param gunController A gun controller tied to the entity.
     */
    handleGunControls(event, gunController) {
        if (event.code === KeyBindings.TOGGLE_FIRING_MODE)
            gunController.getSelected.getFiringModeManager.getNext();
        if (event.code === KeyBindings.DRAW_PRIMARY_WEAPON)
            gunController.changeWeapon("primaryWeapon");
        if (event.code === KeyBindings.DRAW_SECONDARY_WEAPON)
            gunController.changeWeapon("secondaryWeapon");
    }
    get getFORWARD() {
        return this.FORWARD;
    }
    get getBACK() {
        return this.BACK;
    }
    get getLEFT() {
        return this.LEFT;
    }
    get getRIGHT() {
        return this.RIGHT;
    }
    get getRUNNING() {
        return this.RUNNING;
    }
    get getJUMPING() {
        return this.JUMPING;
    }
    get getSHOOTING() {
        return this.SHOOTING;
    }
    get getAIMING() {
        return this.AIMING;
    }
    get getRotation() {
        return this.pointerLockControls.getRotation;
    }
    get getPointerLockControls() {
        return this.pointerLockControls;
    }
    static getInstance(gunController) {
        if (!PlayerInputController.instance)
            PlayerInputController.instance = new PlayerInputController(gunController);
        return PlayerInputController.instance;
    }
}
export { PlayerInputController };
